export default "__VITE_ASSET__DqyEzKVb__"